// ============================================
// HOOK - Tour "visto" persistido en backend + localStorage
// ============================================
// Combina useTourSeen (packages/ui, localStorage — caché instantánea, evita
// parpadeo mientras carga el backend) con el registro en backend
// (packages/core, tabla tour_visto — autoritativo, sobrevive borrar
// localStorage o cambiar de navegador/dispositivo).
//
// Vive en apps/web (no en packages/ui ni packages/core) porque necesita
// combinar un hook de UI pura (useTourSeen) con hooks de red (useToursVistos,
// useAuthStore) sin invertir la dependencia entre esos dos paquetes.

import { useAuthStore, useToursVistos, useMarcarTourVisto } from '@almacenes/core';
import { useTourSeen } from '@almacenes/ui';

export const useTourPersistido = (tourId: string, version: string) => {
  const session = useAuthStore((state) => state.session);
  // session.user.id (no el `usuario` del store): es el que se hidrata al
  // restaurar sesión desde el refresh token.
  const usuarioId = session?.user?.id?.toString();

  const { seen: seenLocal, markAsSeen: markLocal } = useTourSeen(usuarioId, tourId, version);
  const { data: vistosBackend, isLoading: isLoadingVistos } = useToursVistos();
  const marcarVisto = useMarcarTourVisto();

  const vistoEnBackend = vistosBackend?.includes(`${tourId}:${version}`) ?? false;
  // No disparar hasta tener una señal clara de "no visto" en ambas fuentes:
  // mientras el backend no responde, se confía en localStorage (conservador,
  // evita mostrar un tour que el usuario ya vio en otro dispositivo).
  const seen = seenLocal || vistoEnBackend || isLoadingVistos;

  const markAsSeen = () => {
    markLocal();
    marcarVisto.mutate({ tourId, version });
  };

  return { seen, markAsSeen };
};
